import { create } from 'zustand';

/**
 * Process Store - Pure State Management
 * Rule: NO API IN STORE - Only state mutations
 * API calls are handled by ProcessIntegration
 */
const useProcessStore = create((set) => ({
  // State
  processes: [],
  processesForDropdown: [],
  columnFilters: {},
  uniqueValues: {},
  paginationData: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  },
  loading: false,
  error: null,
  selectedProcess: null,
  isEditing: false,
  isCreating: false,
  lastUpdated: null,

  // Pure State Mutations - NO API CALLS
  setProcesses: (processes) => set({
    processes,
    lastUpdated: new Date().toISOString()
  }),

  setProcessesForDropdown: (processesForDropdown) => set({ processesForDropdown }),

  setPaginationData: (paginationData) => set({ paginationData }),

  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  setColumnFilters: (columnFilters) => set({ columnFilters }),

  setLoading: (loading) => set({ loading }),

  setError: (error) => set({ error }),

  clearError: () => set({ error: null }),

  // UI Actions
  startCreating: () => set({
    isCreating: true,
    isEditing: false,
    selectedProcess: null
  }),

  startEditing: (process) => set({
    isEditing: true,
    isCreating: false,
    selectedProcess: process
  }),

  cancelEditing: () => set({
    isEditing: false,
    isCreating: false,
    selectedProcess: null
  }),

  setSelectedProcess: (process) => set({
    selectedProcess: process
  }),

  reset: () => set({
    processes: [],
    processesForDropdown: [],
    columnFilters: {},
    uniqueValues: {},
    paginationData: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      itemsPerPage: 10,
      hasNextPage: false,
      hasPreviousPage: false,
    },
    loading: false,
    error: null,
    selectedProcess: null,
    isEditing: false,
    isCreating: false,
    lastUpdated: null,
  }),
}));

export { useProcessStore };
